export class FormError extends Error{
    constructor(message:string){
        super(message);
        this.name = "FormError"
    }
}


export function checkLinkFormData<T extends object, K extends keyof T>(obj: T, key: K): void {
    if (!(key in obj) || obj[key] === null || obj[key] === undefined) {
        throw new FormError(`Property "${String(key)}" is missing or has an invalid value.`);
    }
}

export function checkNestedProperty<T extends object, K extends keyof T>(obj: T, key: K): void {
    console.log(obj)
    if (!obj?.[key] || obj[key] === null || obj[key] === undefined) {
      throw new Error(`Property "${String(key)}" is missing or invalid.`);
    }
  }